<div class="headerr">
  <div class="logo-conatiner">
      <div class="logo">
          <img id="logoImg" [src]="mainService.accountImageUrl" alt="" width="85px" height="85px">
      </div>
  </div>
  <div class="data-cont">
      <div class="upper">
          <div class="account">

              <div class="authority">
                  {{mainService.accInfo['account_name']}}

              </div>
              <div class="acname">
                  Online Management System
              </div>
          </div>
          <div class="profile_noti">
              <div class="lang d-flex">
                  <!-- ENGLISH -->
                  <div class="full-screen">
                      <ng-select [multiple]="false" class="custom-ng-select" placeholder="Select Language" [items]="auth.allLanguage"
                          bindLabel="language_desc" bindValue="language_cd" [selectableGroup]="true"
                          [selectableGroupAsModel]="false" aria-placeholder="Select Language Code"
                          [closeOnSelect]="true" name="language_cd" [(ngModel)]="auth.language_cd"
                          (change)="changeLanguage()" style="width:100%">
                      </ng-select>
                  </div>
              </div>
              <div class="noti" style="margin: 0 7px;">

                  <div class="dropdown dropdown-inbox text-center form-inline   ">
                      <a class="nav-link dropdown-toggle my-2 my-lg-0 text-center form-inline" [routerLink]="['/task']"
                          data-toggle="dropdown"><i class="fa fa-envelope-o font-weight-bold text-white" style="font-size: 2.5rem;"></i>
                          <sub class="font-weight-bold" style="margin-left: 5px; color: white;font-size: 1.5rem;">{{mainService.count}}</sub>
                      </a>
                      <!-- <ul class="dropdown-menu dropdown-menu-right dropdown-menu-media">
                          <li class="dropdown-menu-header">
                              <div>
                                  <span><strong>{{mainService.count}} New</strong> Messages</span>
                                  <a class="pull-right" [routerLink]="['/task']"
                                      routerLinkActive="router-link-active">view
                                      all</a>
                              </div>
                          </li>
                      </ul> -->
                  </div>
              </div>
              <div class="roleDropdown">
                  <div class="nav-item full-screen">
                      <a class="nav-link dropdown-toggle link nav-item " data-bs-toggle="dropdown" id="navbarDropdown" role="button" aria-expanded="false">
                          <img [src]="mainService.profileImageUrl" style="border-radius: 50px;" width="35px"
                              height="35px" />
                          <span
                              class=" r-font-s font-weight-bold text-white ml-2">{{this.erpUser['party_name']}}</span><i
                              class="fa fa-angle-down m-l-5 font-weight-bold text-white"></i></a>
                      <ul class="dropdown-menu dropdown-menu-left ">
                          <a class="dropdown-item " [routerLink]="['/profile']"
                              routerLinkActive="router-link-active"><i class="fa fa-user"></i>Profile</a>
                          <a [hidden]="hidden" class="dropdown-item" [routerLink]="['/acc']"
                              routerLinkActive="router-link-active"><i class="fa fa-user-plus"></i>Account</a>
                          <a class="dropdown-item" (click)="logOut()"><i
                                  class="fa fa-power-off"></i>Logout</a>
                      </ul>
                  </div>
              </div>

          </div>
          <div class="hamburger">
              <button (click)="toggle()" style="border: none ; border-radius: 50px;">
                  <a>
                      <img src="../../../assets/img/newHeader/more.png" id="hamBurgerLogo" alt="" width="40px"
                          height="40px" />
                      <!-- <i class="fa fa-bars" aria-hidden="true"></i> -->
                      <!-- <i class="navbar-toggler-icon"></i> -->
                  </a>
              </button>
          </div>

      </div>
      <div class="lowerrr">
          <div class="cardss">
              <div class="role-cards">
                  <div class="cardLogo">
                      <img [src]="mainService.Info1ImageUrl" style="border-radius: 50px;
                      position: relative;
                      top: 2.25px;
                      right: 20px;" alt="" width="40px" height="40px" />
                  </div>
                  <div class="card-data">
                      <div class="dp">
                          {{mainService.info1['name']}}
                      </div>
                      <div class="roleNamee">
                          ({{mainService.info1['designation_cd']}})
                      </div>
                  </div>
              </div>


              <div class="role-cards">
                  <div class="cardLogo">
                      <img [src]="mainService.Info2ImageUrl" style="border-radius: 50px;
                      position: relative;
                      top: 2.25px;
                      right: 20px;" alt="" width="40px" height="40px" />
                  </div>
                  <div class="card-data">
                      <div class="dp">
                          {{mainService.info2['name']}}
                      </div>
                      <div class="roleNamee">

                          ({{mainService.info2['designation_cd']}})
                      </div>
                  </div>
              </div>



              <div class="role-cards">
                  <div class="cardLogo">
                      <img [src]="mainService.Info3ImageUrl" style="border-radius: 50px;
                      position: relative;
                      top: 2.25px;
                      right: 20px;" alt="" width="40px" height="40px" />
                  </div>
                  <div class="card-data">
                      <div class="dp">
                          {{mainService.info3['name']}}
                      </div>
                      <div class="roleNamee">

                          ({{mainService.info3['designation_cd']}})
                      </div>
                  </div>
              </div>

              <div class="role-cards">
                  <div class="cardLogo">
                      <img [src]="mainService.Info4ImageUrl" style="border-radius: 50px;
                      position: relative;
                      top: 2.25px;
                      right: 20px;" alt="" width="40px" height="40px" />
                  </div>
                  <div class="card-data">
                      <div class="dp">
                          {{mainService.info4['name']}}
                      </div>
                      <div class="roleNamee">

                          ({{mainService.info4['designation_cd']}})
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<div id="model">
  <div class="myCard2">
      <div class="myCard">
          <div class="myCsrd_pic" style="margin-right: 6px;">
              <img [src]="mainService.Info4ImageUrl" style="border-radius: 50px" alt="" width="50px" height="50px">
          </div>
          <div class="myCard_Cont">
              <div class="dp">
                  {{mainService.info4['name']}}
              </div>
              <div class="roleNamee">
                  ({{mainService.info4['designation_cd']}})
              </div>
          </div>
      </div>

      <div class="myCard">
          <div class="myCsrd_pic" style="margin-right: 6px;">
              <img [src]="mainService.Info3ImageUrl" style="border-radius: 50px" alt="" width="50px" height="50px">
          </div>
          <div class="myCard_Cont">
              <div class="dp">
                  {{mainService.info3['name']}}
              </div>
              <div class="roleNamee">
                  ({{mainService.info3['designation_cd']}})
              </div>
          </div>
      </div>

      <div class="myCard">
          <div class="myCsrd_pic" style="margin-right: 6px;">
              <img [src]="mainService.Info2ImageUrl" style="border-radius: 50px" alt="" width="50px" height="50px">
          </div>
          <div class="myCard_Cont">
              <div class="dp">
                  {{mainService.info2['name']}}
              </div>
              <div class="roleNamee">
                  ({{mainService.info2['designation_cd']}})
              </div>
          </div>
      </div>
      <div class="myCard">
          <div class="myCsrd_pic" style="margin-right: 6px;">
              <img [src]="mainService.Info1ImageUrl" style="border-radius: 50px" alt="" width="50px" height="50px">
          </div>
          <div class="myCard_Cont">
              <div class="dp">
                  {{mainService.info1['name']}}
              </div>
              <div class="roleNamee">
                  ( {{mainService.info1['designation_cd']}})
              </div>
          </div>
      </div>
      <div class="myCard">
          <div class="select-language" style="width: 100%;">
              <ng-select [multiple]="false" placeholder="Select Language" [items]="auth.allLanguage"
                  bindLabel="language_desc" bindValue="language_cd" [selectableGroup]="true"
                  [selectableGroupAsModel]="false" aria-placeholder="Select Language Code" [closeOnSelect]="true"
                  name="language_cd" [(ngModel)]="auth.language_cd" (change)="changeLanguage()" style="width:100%">
              </ng-select>
          </div>
      </div>
  </div>
  <br>
</div>


<div id="model2">
  <div class="tasks_profile">
      <div class="tasks">
          <div class="tasktext">
              Your task :-
              <a class="nav-item nav-link-edit text-dark" [routerLink]="['/task']">{{mainService.count}}</a>
          </div>
      </div>
      <div class="profile">
          <div class="profileDrop">
              <div class="roleDropdown">
                  <div class="nav-item full-screen">
                      <a class="nav-link dropdown-toggle link nav-item " data-bs-toggle="dropdown" id="navbarDropdown" role="button" aria-expanded="false">
                          <img [src]="mainService.profileImageUrl" style="border-radius: 50px;margin: 0 4px;" width="35px"
                              height="35px" />
                          <span class=" r-font-s font-weight-bold text-black">{{this.erpUser['party_name']}}</span><i
                              class="fa fa-angle-down m-l-5 font-weight-bold text-black"></i></a>
                      <ul class="dropdown-menu dropdown-menu-left ">
                          <a class="dropdown-item " [routerLink]="['/profile']"
                              routerLinkActive="router-link-active"><i class="fa fa-user"></i>Profile</a>
                          <a [hidden]="hidden" class="dropdown-item" [routerLink]="['/acc']"
                              routerLinkActive="router-link-active"><i class="fa fa-user-plus"></i>Account</a>
                          <a class="dropdown-item" [routerLink]="['/login']" routerLinkActive="router-link-active"><i
                                  class="fa fa-power-off"></i>Logout</a>
                      </ul>
                  </div>

              </div>
          </div>
      </div>
  </div>
</div>
